@if (isDesktop()) {
  <div class="desktop-titlebar">
    <div class="desktop-titlebar__brand"></div>
    <div class="desktop-titlebar__controls">
      <button
        type="button"
        class="desktop-titlebar__btn"
        (click)="minimizeWindow()"
        aria-label="Minimize"
      >
        <svg viewBox="0 0 10 10" aria-hidden="true"><path d="M0 5 H10" stroke="currentColor" stroke-width="1" /></svg>
      </button>
      <button
        type="button"
        class="desktop-titlebar__btn"
        (click)="toggleMaximizeWindow()"
        [attr.aria-label]="isMaximized() ? 'Restore' : 'Maximize'"
      >
        @if (isMaximized()) {
          <svg viewBox="0 0 10 10" aria-hidden="true"><rect x="0.5" y="2.5" width="6" height="6" fill="none" stroke="currentColor" stroke-width="1" /><path d="M2.5 2.5 V0.5 H8.5 V6.5 H6.5" fill="none" stroke="currentColor" stroke-width="1" /></svg>
        } @else {
          <svg viewBox="0 0 10 10" aria-hidden="true"><rect x="0.5" y="0.5" width="9" height="9" fill="none" stroke="currentColor" stroke-width="1" /></svg>
        }
      </button>
      <button
        type="button"
        class="desktop-titlebar__btn desktop-titlebar__btn--close"
        (click)="closeWindow()"
        aria-label="Close"
      >
        <svg viewBox="0 0 10 10" aria-hidden="true"><path d="M0 0 L10 10 M10 0 L0 10" stroke="currentColor" stroke-width="1" /></svg>
      </button>
    </div>
  </div>
}
<router-outlet></router-outlet>
<ng-progress id="progressbar" aria-hidden="true"></ng-progress>

<!-- The API notification overlay used to fly in here. Action statuses now go
     to the notification panel behind the bell instead, so there is one place
     to look and nothing dismisses itself before it has been read. The store
     and the overlay component both remain; only this mount point is gone. -->
